module.exports = __webpack_public_path__ + "static/integration_bg-c9cf7dfddbea4163e7dd2c324dad4719.jpg";